import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Grid, Message } from 'semantic-ui-react';
import { Field } from 'react-final-form';

import WarningMessage from 'components/WarningMessage';

import { makeSelectUsersMeValue } from 'services/usersMe/selectors';
import { AppState } from 'services/types';

import { makeSelectInitialValues } from '../../../../selectors';
import { PersonFormIntialValues } from '../../../../types';
import { ProfileFieldName } from '../../../../constants';

interface OwnProps {
    personId?: number;
}

interface ConnectedProps {
    initialValues: PersonFormIntialValues;
    userId: number;
}

type Props = OwnProps & ConnectedProps;

export class ProfileMessagesComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { initialValues, userId } = this.props;

        return (
            <Field
                name={ProfileFieldName.EMAIL}
                subscription={{ dirty: true, value: true }}
            >
                {({
                    meta: { dirty },
                    input: { value }
                }): React.ReactElement => (
                    <React.Fragment>
                        {initialValues?.userId === userId && dirty ? (
                            <Grid.Column width={16}>
                                <WarningMessage
                                    title="Warning"
                                    content="Updating your own email will log you out automatically. You will need to login again."
                                    visible
                                />
                            </Grid.Column>
                        ) : null}
                        {!initialValues?.email && value ? (
                            <Grid.Column width={16}>
                                <Message
                                    info
                                    header="Information"
                                    content="An email will be sent to this user with instructions to setup their password."
                                />
                            </Grid.Column>
                        ) : null}
                    </React.Fragment>
                )}
            </Field>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    initialValues: makeSelectInitialValues(),
    userId: makeSelectUsersMeValue('id')
});

export default connect(mapStateToProps)(ProfileMessagesComponent);
